import React from 'react'
import CustomersTable from '../tables/CustomersTable'

const Customers = () => {
  return (
    <CustomersTable/>
  )
}

export default Customers